angular.module('impactx.company').directive('ixCompanyControlSetting', function() {
    return {
        restrict: 'E',
        scope: {
            controlSetting: "=",
            trns: "="
        },
        controller: "CompanyControlSettingCtrl",
        controllerAs: "companyControlSettingCtrl",
        templateUrl: "modules/company/templates/company-control-setting.html"
    }
});